import { useEffect, useState } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { DASHBOARD_AUTH_CHANGED_EVENT, getDashboardToken } from '@/api/apiService';

/** Blocks the app until a dashboard session token exists; otherwise sends users to login. */
const RequireAuth = () => {
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(true);
  const [isAuthed, setIsAuthed] = useState(false);

  useEffect(() => {
    let mounted = true;

    const refresh = () => {
      const token = getDashboardToken();
      if (!mounted) return;
      setIsAuthed(Boolean(token));
      setIsLoading(false);
    };

    refresh();
    const onAuthChanged = () => refresh();
    window.addEventListener(DASHBOARD_AUTH_CHANGED_EVENT, onAuthChanged as EventListener);
    return () => {
      mounted = false;
      window.removeEventListener(DASHBOARD_AUTH_CHANGED_EVENT, onAuthChanged as EventListener);
    };
  }, [location.pathname]);

  if (isLoading) {
    return <div className="p-6 text-sm text-muted-foreground">Checking access...</div>;
  }

  if (!isAuthed) {
    return <Navigate to="/dashboard" replace state={{ from: location.pathname }} />;
  }

  return <Outlet />;
};

export default RequireAuth;
